import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "writing"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "font-weight": "700"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "question"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "answer"
};
const _hoisted_8 = {
  class: "textarea-box"
};
const _hoisted_9 = {
  class: "textarea-pre"
};
const _hoisted_10 = {
  class: "pre",
  style: {
    "display": "block",
    "visibility": "hidden"
  }
};
const _hoisted_11 = {
  style: {
    "text-align": "right"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.questionInfo.skill == 'S1' || $props.questionInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.questionInfo.itemName), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "question-text",
    innerHTML: $setup.itemText
  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[6] || (_cache[6] = _createElementVNode("p", null, "正式作答区（请在以下区域书写正文）", -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("pre", _hoisted_10, [_createTextVNode("              " + _toDisplayString($setup.answer[$setup.questionId]), 1), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)), _cache[5] || (_cache[5] = _createTextVNode("\n            ", -1))]), _withDirectives(_createElementVNode("textarea", {
    id: "textarea",
    style: {
      "border": "2px solid #666"
    },
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.answer[$setup.questionId] = $event),
    onInput: _cache[1] || (_cache[1] = $event => $setup.setAnswer()),
    onBlur: _cache[2] || (_cache[2] = $event => $setup.setAnswer('save'))
  }, null, 544), [[_vModelText, $setup.answer[$setup.questionId]]])]), _createElementVNode("p", _hoisted_11, "（共" + _toDisplayString($setup.wordsNo) + "词）", 1)])])])]);
}